<div class="p-grid">
    <!-- menu bar -->
    <div class="p-col-12">
        <p-menubar [model]="menuItems">
          <ng-template pTemplate="start" style="width: 100%;">
            <h2 style="display: inline;">Workflow - </h2>
            <span style="width: fit-content;">
                <p-toggleButton class="p-mb-2 p-ml-2" onLabel="Active" offLabel="InActive" [onIcon]="'pi pi-check'"
                    [offIcon]="'pi pi-times'" iconPos="right" [(ngModel)]="isActive"
                    (onChange)="loadListingWithFilters()">
                </p-toggleButton>
            </span>
            <!-- <div style="width: fit-content; float: left;">
              <p-dropdown [options]="recentItems" id="recentItems" (onChange)="recentUpdate()"
              [(ngModel)]="selectedRecent" optionLabel="name" appendTo="body" >
              </p-dropdown>
            </div> -->
            <span class="p-input-icon-left" style="float: right; margin: 2px 5px 0px 5px;">
              <i class="pi pi-search"></i>
              <input pInputText type="text" [formControl]="searchControl" placeholder="Search..." />
            </span>
          </ng-template>
          <ng-template pTemplate="end" style="width: 100%;">
          </ng-template>
        </p-menubar>
    </div>

    <!-- bodyArea -->
    <div class="p-col-12">
        <!-- list and split view -->
        <div class="p-grid">
            <div *ngIf="!fromQuery" [ngClass]="{'p-lg-12': selectedView=='list', 'p-lg-3':selectedView=='split'}">
                <div class="card">
                    <p-contextMenu #cm [model]="configMenuItemsCM" (onShow)="buildContextMenu()"></p-contextMenu>
                    <p-table #workflow [columns]="listCols" [value]="workflowListResults"
                    selectionMode="single" [(selection)]="selectedWorkflow" dataKey="id" responsiveLayout="scroll"
                    (onRowSelect)="onRowSelect($event);"
                    (onRowUnselect)="onRowUnselect($event)"
                    [lazy]="true" (onLazyLoad)="getWorkflowListByFilter($event)"
                    [paginator]="true" [rows]="pageSize" [totalRecords]="totalRecords" [(first)]="first"
                    [showCurrentPageReport]="true"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                    [rowsPerPageOptions]="tableShowMore"
                    [(contextMenuSelection)]="selectedWorkflow" [contextMenu]="cm"
                    [ngClass]="{'table-split-paginator': selectedView=='split'}"
                    styleClass="p-datatable-gridlines" [resizableColumns]="true" [style]="{width:'100%'}">


                        <ng-template pTemplate="header" let-columns>
                            <tr>
                              <ng-container *ngFor="let col of columns">
                                <th *ngIf="col.show" [pSortableColumn]="col.field"
                                style="border-right: 1px solid var(--primary-color);" pResizableColumn>
                                    {{col.header}}
                                    <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order">
                                    </p-sortIcon>
                                    <span *ngIf="col.order" class="pi pi-filter p-ml-2 filtericon"
                                        [ngClass]="{'blink_me' : col.value.length > 0}"
                                        (click)="$event.stopPropagation(); curCol = col; op.toggle($event)">
                                    </span>
                                </th>
                              </ng-container>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-rowData let-columns="columns">
                            <tr [pSelectableRow]="rowData" [pContextMenuRow]="rowData">
                                <ng-container *ngFor="let col of columns">
                                    <td *ngIf="col.show" style="text-align: left;">
                                        <ng-container *ngIf="col.field =='name'">
                                            <app-color-box pTooltip="{{rowData?.colorIconTooltip}}" tooltipPosition="bottom" class="colorBoxStyle" [color]="(rowData?.executionStatus=='Pending' || !rowData?.jobId) ? '#6a9119' : '#fe4300'">
                                            </app-color-box>
                                        </ng-container>
                                        <ng-container [ngSwitch]="col?.dataType">
                                            <ng-container *ngSwitchCase="'date'">
                                                {{ rowData[col.field] | localDate }}
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'string'">
                                                {{ rowData[col.field] }}
                                            </ng-container>
                                            <ng-container *ngSwitchDefault>
                                                {{ rowData[col.field] }}
                                            </ng-container>
                                        </ng-container>
                                    </td>
                                </ng-container>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                            <tr>
                                <td colspan="9">{{noWfFindOrLoadingText}}</td>
                            </tr>
                        </ng-template>
                    </p-table>
                    <p-overlayPanel #op [showCloseIcon]="false" [dismissable]="true">
                        <ng-template pTemplate>
                          <input pInputText type="text" #inputS [(ngModel)]="curCol.value"
                            (input)="workflow.filter(curCol.value, curCol.field, 'contains')"
                            placeholder="Search by {{curCol.header}}" class="p-column-filter"
                            [value]="workflow.filters[curCol.field] ? workflow.filters[curCol.field].value : ''">
                        </ng-template>
                    </p-overlayPanel>
                </div>
            </div>
            <!-- From Query table -->
            <div class="p-lg-3" *ngIf="selectedView == 'split' && fromQuery">
                <app-global-search-table [isVisible]="fromQuery" [globalSearchData]="globalSearchData" (refresh)="refreshList($event)"> </app-global-search-table>
            </div>
            <div class="p-col-12 p-lg-9" *ngIf="selectedView == 'split' && selectedWorkflow">
                <app-workflow-details
                    [selectedWorkflowBlock]="selectedWorkflowBlock"
                    [fromQuery]="fromQuery"
                    (viewClosed)="listView()"
                    (loadList)="loadNewList($event)"
                    (reloadList)="loadCurrentPage()"
                    (showEditWorkflow)="showEditWorkflow($event)"
                    (deleteSavedSearch)="deleteSavedSearch($event)"
                ></app-workflow-details>
            </div>
        </div>
    </div>
</div>

<app-add-edit-workflow-dialog *ngIf="displayNewWorkflow" [displayAddEditDialog]="displayNewWorkflow" [workflowCopy]="workflowCopy" [workflowViewOnly]="workflowViewOnly" [workflowEditId]="workflowEditId" (dialogClosed)="cancelWorkflow()" (loadNewList)="loadNewList($event)"></app-add-edit-workflow-dialog>
<p-toast position="top-right" [baseZIndex]="10000"></p-toast>
<p-confirmDialog [style]="{width: '20vw'}"></p-confirmDialog>
